import React from 'react';
import { Tracker } from '@formily/reactive';
import { GarbageCollector } from '../shared';
import { useForceUpdate } from './useForceUpdate';
var AutoCollector = (function () {
    function AutoCollector() {
    }
    return AutoCollector;
}());
export var useObserver = function (view, options) {
    var forceUpdate = useForceUpdate();
    var unmountRef = React.useRef(false);
    var gcRef = React.useRef();
    var tracker = React.useMemo(function () {
        return new Tracker(function () {
            if (typeof (options === null || options === void 0 ? void 0 : options.scheduler) === 'function') {
                options.scheduler(forceUpdate);
            }
            else {
                forceUpdate();
            }
        }, options === null || options === void 0 ? void 0 : options.displayName);
    }, []);
    if (!gcRef.current) {
        gcRef.current = new GarbageCollector(function () {
            if (tracker) {
                tracker.dispose();
            }
        });
        gcRef.current.open(new AutoCollector());
    }
    React.useEffect(function () {
        unmountRef.current = false;
        gcRef.current.close();
        return function () {
            unmountRef.current = true;
            if (tracker) {
                tracker.dispose();
            }
        };
    }, []);
    return tracker.track(view);
};
